import { render } from "./overview.vue?vue&type=template&id=bfd21a52&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"

import "./overview.vue?vue&type=style&index=0&id=bfd21a52&lang=scss&scoped=true"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd21a52"]])

export default __exports__